import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-object" }
const _hoisted_2 = ["src"]

import portrait from "@/assets/spanol.png";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeImageComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", {
      class: "hero-object__backplate",
      "aria-hidden": "true"
    }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "hero-object__edge",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("img", {
      class: "hero-object__image",
      src: _unref(portrait),
      alt: "Retrato de Vinicius Spanol"
    }, null, 8, _hoisted_2),
    _cache[2] || (_cache[2] = _createElementVNode("span", {
      class: "hero-object__coordinate",
      "aria-hidden": "true"
    }, "V / 01", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("figcaption", { class: "hero-object__caption" }, [
      _createElementVNode("span", null, [
        _createElementVNode("strong", null, "VINICIUS SPANOL"),
        _createElementVNode("small", null, "FULLSTACK DEVELOPER")
      ]),
      _createElementVNode("span", { "aria-hidden": "true" }, "2026")
    ], -1))
  ]))
}
}

})